import { Theme } from '@mui/material/styles';

export const selectField = (theme: Theme) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),

    '& .MuiInputLabel-root': {
        display:'flex',
        flexDirection: 'row-reverse',
        whiteSpace: 'nowrap',

        '&.Mui-focused': {
            color: 'text.secondary',
        },

        '&.Mui-error': {
            color: 'text.secondary',
        },

        '& .MuiFormLabel-asterisk': {
            '&.Mui-focused': {
                color: 'text.secondary',
            },

            '&.Mui-error': {
                color: 'text.secondary',
            },
        },
    },

    '& .MuiInputBase-root': {
        '&.Mui-disabled': {
            '& fieldset': {
                borderColor: 'darkGray.main',
            },

            '&:hover fieldset': {
                borderColor: 'darkGray.dark',
            },
        },

        '& fieldset': {
            borderColor: 'darkGray.main',
            borderWidth: '1px',
            borderRadius: 0,
        },

        '&:hover fieldset': {
            borderColor: 'darkGray.dark',
        },

        '&.Mui-focused fieldset': {
            borderWidth: '1px',
            borderColor: 'darkGray.dark',
        },

        '&.Mui-error fieldset': {
            borderColor: 'darkGray.dark',
        },

        '& .MuiInputBase-input': {
            color: 'text.secondary',
            paddingTop: theme.spacing(1.375),
            paddingBottom: theme.spacing(1.5),
            fontSize: 12,
        }
    },
}) as const;

export const helper = (theme: Theme) => ({
    marginLeft: 0,
    marginTop: theme.spacing(0.5),
}) as const;

